/*
 * GENERATED — do not edit manually. Run: pnpm gen:components
 * Source: packages/ui-theme/contracts/input.contract.json
 * Styles: @indipia/styles/components.css (토큰 구동 의미 클래스)
 */
import React from 'react';
import { cx } from '../cx';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  error?: string;
  success?: string;
  size?: 'sm' | 'md' | 'lg';
  width?: 'default' | 'fill' | 'auto';
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, required, success, size = 'md', width = 'default', className = '', id, ...props }: InputProps,
  ref,
) {
  return (
    <div className={cx('field', error ? 'error' : success ? 'success' : '', width !== 'default' && `field-${width}`, className)}>
      {label && <label htmlFor={id}>{label}{required && <span className="req" aria-hidden="true">*</span>}</label>}
      <input id={id} ref={ref} className={cx('input', size !== 'md' && `input-${size}`)} required={required} {...props} />
      {(error || success) && <span className="help">{error || success}</span>}
    </div>
  );
});
